import { useContext } from 'react';
import { LocaleContext } from '../contexts';
export { Trans } from 'react-i18next';
export const useTranslation = (ns, options) => {
    const { useTranslation } = useContext(LocaleContext);
    return useTranslation(ns, options);
};
